import useSWR from 'swr'

import { RestaurantPhotoClipPrivacyType } from '~/api-definition/enumTypes'
import {
  ImageResponse,
  RestaurantPhotoClipResponse,
  RestaurantPhotoClipsResponse,
  RestaurantResponse,
  RestaurantsResponse,
} from '~/api-definition/response'
import { config } from '~/config'

import { superFetch } from '..'

export const restaurantGetRestaurant = (args: {
  searchParams: {
    restaurant_id?: string
    referral_restaurant_url?: string
  }
}) => {
  return superFetch<RestaurantResponse>(
    config.api.url('/restaurant/restaurant', {
      searchParams: args.searchParams,
    })
  )
}

export const restaurantSearchRestaurants = (args: {
  searchParams: { key: string }
}) => {
  return superFetch<RestaurantsResponse>(
    config.api.url('/restaurant/search_restaurants', {
      searchParams: args.searchParams,
    })
  )
}

export const restaurantRestaurantPhotoClips = (args: {
  searchParams: {
    restaurant_id: string
    count?: number
    cursor_next?: string
    cursor_before?: string
  }
}) => {
  return superFetch<RestaurantPhotoClipsResponse>(
    config.api.url('/restaurant/restaurant_photo_clips', {
      searchParams: args.searchParams,
    })
  )
}

export const restaurantRestaurantPhotoClip = (args: {
  accessToken?: string
  searchParams: { restaurant_photo_clip_id: string }
}) => {
  return superFetch<RestaurantPhotoClipResponse>(
    config.api.url('/restaurant/restaurant_photo_clip', {
      searchParams: args.searchParams,
    }),
    {
      method: 'GET',
      headers: args.accessToken
        ? {
            Authorization: `Bearer ${args.accessToken}`,
          }
        : undefined,
    }
  )
}

export const restaurantNewRestaurantPhotoClipImage = (args: {
  accessToken: string
  body: {
    restaurant_id: string
    image_file: File
  }
}) => {
  const headers: Record<string, string> = {}
  if (args.accessToken) {
    headers['Authorization'] = `Bearer ${args.accessToken}`
  }
  return superFetch<ImageResponse>(
    config.api.url('/restaurant/new_restaurant_photo_clip_image'),
    {
      method: 'POST',
      contentType: 'multipart/form-data',
      headers,
      body: args.body,
    }
  )
}

export const restaurantNewRestaurantPhotoClip = (args: {
  accessToken: string
  body: {
    restaurant_id: string
    privacy_type: RestaurantPhotoClipPrivacyType
    image_ids: string[]
    visited_date?: string
  }
}) => {
  const headers: Record<string, string> = {}
  if (args.accessToken) {
    headers['Authorization'] = `Bearer ${args.accessToken}`
  }
  return superFetch<RestaurantPhotoClipResponse>(
    config.api.url('/restaurant/new_restaurant_photo_clip'),
    {
      method: 'POST',
      contentType: 'multipart/form-data',
      headers,
      body: args.body,
    }
  )
}

export const restaurantUpdateRestaurantPhotoClip = (args: {
  accessToken: string
  body: {
    restaurant_photo_clip_id: string
    privacy_type: RestaurantPhotoClipPrivacyType
    image_ids: string[]
    visited_date?: string
  }
}) => {
  const headers: Record<string, string> = {}
  if (args.accessToken) {
    headers['Authorization'] = `Bearer ${args.accessToken}`
  }
  return superFetch<RestaurantPhotoClipResponse>(
    config.api.url('/restaurant/update_restaurant_photo_clip'),
    {
      method: 'PUT',
      contentType: 'multipart/form-data',
      headers,
      body: args.body,
    }
  )
}

export const restaurantDeleteRestaurantPhotoClip = (args: {
  accessToken: string
  searchParams: {
    restaurant_photo_clip_id: string
  }
}) => {
  const headers: Record<string, string> = {}
  if (args.accessToken) {
    headers['Authorization'] = `Bearer ${args.accessToken}`
  }
  return superFetch<RestaurantPhotoClipResponse>(
    config.api.url('/restaurant/delete_restaurant_photo_clip', {
      searchParams: args.searchParams,
    }),
    {
      method: 'DELETE',
      headers,
    }
  )
}

// Hooks

export const useSearchRestaurants = (args: {
  searchParams: { key: string; count?: number }
}) => {
  return useSWR(
    args.searchParams.key === ''
      ? null
      : config.api.url('/restaurant/search_restaurants', {
          searchParams: args.searchParams,
        }),
    () => restaurantSearchRestaurants(args)
  )
}
